module.exports = __webpack_public_path__ + "static/media/TournamentTent_1.44e3a929.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/tournamenttent/TournamentTent_1.png
// module id = 1327
// module chunks = 3